import { ChangeEvent } from 'react';
import { DropdownProps } from 'react-day-picker';

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/common';

export const MonthsDropdown = (props: DropdownProps) => {
  const { options, value, onChange, 'aria-label': ariaLabel } = props;

  const onValueChange = (newValue: string) => {
    if (onChange) {
      const syntheticEvent = {
        target: {
          value: newValue,
        },
      } as ChangeEvent<HTMLSelectElement>;

      onChange(syntheticEvent);
    }
  };

  return (
    <Select className="order-1" value={value?.toString()} onValueChange={onValueChange}>
      <SelectTrigger
        size="sm"
        className="border-none pr-7 !shadow-none [&_svg]:right-2 [&_svg]:!text-brand-primary-base text-brand-primary-base data-[state=open]:bg-brand-primary-lightest"
        aria-label={ariaLabel}
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="h-[256px]">
        <SelectGroup>
          {options?.map((option) => (
            <SelectItem
              key={option.value}
              value={option.value.toString()}
              disabled={option.disabled}
            >
              {option.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};
